import React, { useEffect, useState } from 'react'
import {
  Badge,
  Button,
  ButtonGroup,
  ButtonToolbar,
  Col,
  Form,
  Image,
  InputGroup,
  OverlayTrigger,
  Row,
  Table,
  Tooltip
} from 'react-bootstrap'
import NavTitle from '../../components/nav-title'
import { BsPlusLg, BsSearch } from 'react-icons/bs'
import { cancelHolidayAPI, getHolidayAPI } from '../../services/holiday'
import SwalCustom from '../../alert/swal-custom'
import Error_false from '../../components/error/error-false'
import EditHoliday from '../../components/holiday-setting/holiday/edit-holiday'
import moment from 'moment'
import UseTypeHoliday from '../../hooks/use-type-holiday'
import AddHoliday from '../../components/holiday-setting/holiday/add-holiday'
import { TXTSUCCESS } from '../../Constants'
import { PaginationControl } from 'react-bootstrap-pagination-control'
import UseTypeYearSearch from '../../hooks/use-type-year'
import TextNavTitle from '../../components/TextNavTitle'
import editImg from '../../images/Edit.svg'
import cancelImg from '../../images/Cancel.svg'
import CardCustom from '../../components/custom/card-custom'
import TableSkeletonBody from '../../components/custom/TableSkeletonBody'
import { Controller, useForm } from 'react-hook-form'
import AutocompleteCustom from '../../components/custom/autocomplete'

export default function HolidayPage() {
  const [showCreate, setShowCreate] = useState(false)
  const [dataTable, setdataTable] = useState([])
  const [showEdit, setShowEdit] = useState(false)
  const [detailTable, setDetailTable] = useState()
  const type = UseTypeHoliday()
  const [typeValue, setTypeValue] = useState(1)
  const [page, setPage] = useState(1)
  const [totalRows, setTotalRows] = useState(0)
  const [totalLimits, setTotalLimits] = useState(0)
  const typeYears = UseTypeYearSearch()
  const thisYear = new Date().getFullYear()
  const [typeYear, setTypeYear] = useState({ label: thisYear, value: thisYear })
  const [isLoading, setIsLoading] = useState(true)

  const [bodyFilter, setBodyFilter] = useState()
  const handleChange = (value) => {
    setTypeValue(value)

    const body = {
      ...bodyFilter,
      page: 1,
      holidayTypeId: value
    }
    getHoliday(body)
    setPage(1)
  }

  useEffect(() => {
    const body = {
      page: 1,
      holidayTypeId: 1,
      year: new Date().getFullYear()
    }
    getHoliday(body)
  }, [])

  const getHoliday = async (body) => {
    setBodyFilter(body)
    setPage(body.page)
    setIsLoading(true)
    const res = await getHolidayAPI(body)
    setIsLoading(false)
    if (!res) return
    if (res.status) {
      setdataTable(res.result)
      setTotalRows(res.totalRows)
      setTotalLimits(res.totalLimits)
    }
  }

  const [isSave, setIsSave] = useState(false)

  const onCancel = (d) => {
    const holidayId = d.id
    SwalCustom({
      title: 'Are you sure?',
      text: 'Do you want to cancel?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Yes, cancel it!'
    }).then((result) => {
      if (result.isConfirmed) {
        setIsSave(true)
        cancelHoliday(holidayId)
      }
    })
  }

  const cancelHoliday = async (holidayId) => {
    const data = await cancelHolidayAPI({ holidayId })
    setIsSave(false)
    if (!data) return
    if (data.status) {
      SwalCustom({
        title: `Success!`,
        text: TXTSUCCESS,
        timer: 1500,
        showConfirmButton: false
      }).then(() => {
        getHoliday(bodyFilter)
      })
    } else {
      Error_false(data)
    }
  }

  const handleEditButtonClick = () => {
    setShowEdit(true)
  }

  const { control, handleSubmit } = useForm()

  const onSearch = (d) => {
    const body = {
      ...bodyFilter,
      page: 1,
      search: d.search ?? ''
    }
    getHoliday(body)
    setPage(1)
  }

  return (
    <Row>
      <NavTitle>
        <TextNavTitle>Setting Holiday</TextNavTitle>
      </NavTitle>
      <div>
        <ButtonGroup
          aria-label="Basic example"
          style={{ borderRadius: '0.375rem', width: '180px' }}
          className="shadow-sm "
        >
          {type.length > 1 ? (
            type.map((d, i) => (
              <Button
                key={`btn-${i}`}
                variant={
                  d.value === typeValue ? 'custom-active' : 'custom-default'
                }
                className="px-3"
                onClick={() => {
                  handleChange(d.value)
                }}
              >
                {d.label}
              </Button>
            ))
          ) : (
            <>{type.label}</>
          )}
        </ButtonGroup>
      </div>
      <Col xl={12} className="mt-3">
        <CardCustom
          border="0"
          minHeight={'85vh'}
          className=" shadow-sm  d-flex justify-content-between"
        >
          <div>
            <div className="p-3 ">
              <Row>
                <Col
                  xl={12}
                  className="my-auto d-flex gap-3 justify-content-between"
                  style={{ flexWrap: 'wrap' }}
                >
                  <label
                    className=" my-auto fw-bold"
                    style={{
                      fontSize: '14px'
                    }}
                  >
                    Total: {totalRows?.toLocaleString()}
                  </label>

                  <div className=" d-flex gap-2 ">
                    <Form onSubmit={handleSubmit(onSearch)}>
                      <Form.Group className="" style={{ minWidth: 400 }}>
                        <Controller
                          name={'search'}
                          control={control}
                          render={({ field: { onChange, value = '' } }) => (
                            <InputGroup className="">
                              <InputGroup.Text className="bg-white border-end-0  text-muted">
                                <BsSearch />
                              </InputGroup.Text>
                              <Form.Control
                                value={value}
                                placeholder="Search"
                                onChange={onChange}
                                className="border-start-0 ps-0 placeholder-text"
                              />
                            </InputGroup>
                          )}
                        />
                      </Form.Group>
                    </Form>
                    <div className="me-2" style={{ minWidth: '80px' }}>
                      {/* <Select
                      className="w-100 "
                      allowClear
                      options={typeYears}
                      onChange={(e) => {
                        setTypeYear(e)
                        const body = {
                          ...bodyFilter,
                          page: 1,
                          year: e
                        }
                        getHoliday(body)
                      }}
                      value={typeYear}
                      placeholder="Year"
                    />{' '} */}
                      <AutocompleteCustom
                        isClearable={false}
                        value={typeYear}
                        options={typeYears}
                        onChange={(e) => {
                          setTypeYear(e)
                          const body = {
                            ...bodyFilter,
                            page: 1,
                            year: e.value
                          }
                          getHoliday(body)
                        }}
                      />
                    </div>
                    <Button
                      className="border-0 w-100"
                      size="sm"
                      style={{
                        minWidth: '160px'
                      }}
                      onClick={() => setShowCreate(true)}
                    >
                      <BsPlusLg /> Add Holiday
                    </Button>
                  </div>
                </Col>
              </Row>
            </div>
            {/* <Index /> */}
            <Table hover>
              <thead
                className="bg-hrms"
                style={{ position: 'sticky', top: '0px' }}
              >
                <tr className="fw-light font-title-table">
                  <th className="fw-normal">#</th>
                  <th className="fw-normal">Date</th>
                  <th className="fw-normal">Detail</th>
                  <th className="fw-normal">Status</th>
                  <th className="fw-normal text-center"> Action</th>
                </tr>
              </thead>
              <tbody>
                {isLoading ? (
                  <TableSkeletonBody colSpan={5} rowSpan={10} />
                ) : dataTable.length > 0 ? (
                  dataTable.map((d, i) => (
                    <tr key={i} className="fw-light font-small-2 ">
                      <td> {page * totalLimits - totalLimits + i + 1}</td>
                      <td>{moment(d.date).format('DD/MM/YYYY')}</td>

                      <td lg={2} className="font-small-2">
                        <p className="font-small-2 " style={{ width: '850px' }}>
                          {d.detail}
                        </p>
                      </td>
                      <td>
                        {' '}
                        <Badge
                          className={d.cancel ? 'text-dark' : ''}
                          bg={d.cancel ? 'body-secondary' : 'primary'}
                        >
                          {d.cancel ? 'Cancel' : 'Active'}
                        </Badge>
                      </td>

                      <td className="">
                        <div className="d-flex justify-content-center gap-2">
                          {d.cancel === 1 ? (
                            <>
                              <Button
                                variant="btn btn-outline-primary"
                                className="border-0 d-flex justify-content-center"
                                size="sm"
                                style={{
                                  width: '32px',
                                  height: '32px'
                                }}
                                disabled
                              >
                                <Image
                                  src={editImg}
                                  style={{
                                    width: '20px'
                                  }}
                                />
                              </Button>

                              <ButtonToolbar>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-detail">
                                      Cancel
                                    </Tooltip>
                                  }
                                >
                                  <Button
                                    variant="btn btn-outline-primary"
                                    className="border-0 d-flex justify-content-center"
                                    size="sm"
                                    style={{
                                      width: '32px',
                                      height: '32px'
                                    }}
                                    disabled
                                    onClick={() => onCancel(d)}
                                  >
                                    <Image
                                      src={cancelImg}
                                      style={{
                                        width: '20px'
                                      }}
                                    />
                                  </Button>
                                </OverlayTrigger>
                              </ButtonToolbar>
                              {/* <Button
                              variant="outline-secondary "
                              type="button"
                              size="sm"
                              style={{
                                width: "110px",
                              }}
                            >
                              Edit
                            </Button>
                            <Button size="sm" variant="light">
                              <BsThreeDotsVertical />
                            </Button> */}
                            </>
                          ) : (
                            <>
                              <ButtonToolbar>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-detail">Edit</Tooltip>
                                  }
                                >
                                  <Button
                                    variant="btn btn-outline-primary"
                                    className="border-0 d-flex justify-content-center"
                                    size="sm"
                                    style={{
                                      width: '32px',
                                      height: '32px'
                                    }}
                                    onClick={() => {
                                      setDetailTable(d)
                                      handleEditButtonClick()
                                    }}
                                  >
                                    <Image
                                      src={editImg}
                                      style={{
                                        width: '20px'
                                      }}
                                    />
                                  </Button>
                                </OverlayTrigger>
                              </ButtonToolbar>
                              <ButtonToolbar>
                                <OverlayTrigger
                                  placement="top"
                                  overlay={
                                    <Tooltip id="tooltip-detail">
                                      Cancel
                                    </Tooltip>
                                  }
                                >
                                  <Button
                                    variant="btn btn-outline-primary"
                                    className="border-0 d-flex justify-content-center"
                                    size="sm"
                                    style={{
                                      width: '32px',
                                      height: '32px'
                                    }}
                                    onClick={() => onCancel(d)}
                                  >
                                    <Image
                                      src={cancelImg}
                                      style={{
                                        width: '20px'
                                      }}
                                    />
                                  </Button>
                                </OverlayTrigger>
                              </ButtonToolbar>
                              {/* <Button
                              style={{
                                backgroundColor: "#1A2B45",
                                border: "1px solid #1A2B45",
                                width: "110px",
                              }}
                              type="button"
                              size="sm"
                              onClick={() => {
                                setDetailTable(d);
                                handleEditButtonClick();
                              }}
                            >
                              <span className="menu-active me-2">
                                <Image
                                  src={imgEdit}
                                  style={{ width: "14px", color: "white" }}
                                ></Image>
                              </span>
                              Edit
                            </Button> */}
                              {/* <Dropdown
                              menu={{
                                items: [
                                  {
                                    key: "1",
                                    label: (
                                      <span onClick={() => onCancel(d)}>
                                        {" "}
                                        Cancel
                                      </span>
                                    ),
                                  },
                                ],
                              }}
                            >
                              <Button size="sm" variant="light">
                                <BsThreeDotsVertical />
                              </Button>
                            </Dropdown> */}
                            </>
                          )}
                        </div>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr className="fw-light ">
                    <td colSpan={6} className="text-center">
                      - No data -
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          <div className="pt-3">
            <PaginationControl
              page={page}
              total={totalRows}
              limit={totalLimits}
              changePage={(page) => {
                const body = {
                  ...bodyFilter,
                  page: page
                }
                getHoliday(body)
                setPage(page)
              }}
              ellipsis={1}
            />
          </div>
        </CardCustom>
      </Col>

      {showCreate && (
        <AddHoliday
          setIsSave={setIsSave}
          showCreate={showCreate}
          isSave={isSave}
          fnGetData={() => {
            getHoliday(bodyFilter)
          }}
          setShowCreate={setShowCreate}
        />
      )}
      {showEdit && (
        <EditHoliday
          detail={detailTable}
          setIsSave={setIsSave}
          showCreate={showEdit}
          isSave={isSave}
          fnGetData={() => {
            getHoliday(bodyFilter)
          }}
          setShowCreate={setShowEdit}
        />
      )}
    </Row>
  )
}
